import React, { Component } from 'react';
import { Carousel } from 'react-bootstrap';

import styles from './styles/components/home-slider.scss';

class HomeSlider extends Component {
    render() {
        return (
            <Carousel className={`homepage-slider ${styles.homeSlider}`} interval={10000}>
                {/* Temporal banners */}
                {/* <Carousel.Item
                    className={` ${styles.homeSliderRow}`}
                    style={{ backgroundImage: `url(${require(`../images/carousel/${this.props.locale.currentLocale}/image01-christmas.jpeg`)})`, backgroundSize: 'cover' }}
                >
                    <div className={`container ${styles.sliderContainer}`} />
                </Carousel.Item>
                <Carousel.Item
                    className={` ${styles.homeSliderRow}`}
                    style={{ backgroundImage: `url(${require(`../images/carousel/${this.props.locale.currentLocale}/image02-christmas.jpeg`)})`, backgroundSize: 'cover' }}
                >
                    <div className={`container ${styles.sliderContainer}`} />
                </Carousel.Item>
                <Carousel.Item
                    className={` ${styles.homeSliderRow}`}
                    style={{ backgroundImage: `url(${require(`../images/carousel/${this.props.locale.currentLocale}/image03-christmas.jpeg`)})`, backgroundSize: 'cover' }}
                >
                    <div className={`container ${styles.sliderContainer}`} />
                </Carousel.Item> */}
                {/* Official banners */}
                <Carousel.Item
                    className={` ${styles.homeSliderRow}`}
                    style={{ backgroundImage: `url(${require(`../images/carousel/${this.props.locale.currentLocale}/image01.jpg`)})`, backgroundSize: 'cover' }}
                >
                    <div className={`container ${styles.sliderContainer}`} />
                </Carousel.Item>
                {/* <Carousel.Item
                    className={` ${styles.homeSliderRow}`}
                    style={{ backgroundImage: `url(${require(`../images/carousel/${this.props.locale.currentLocale}/image04.jpg`)})`, backgroundSize: 'cover' }}
                >
                    <div className={`container ${styles.sliderContainer}`} />
                </Carousel.Item> */}
            </Carousel>
        );
    }
}

export default HomeSlider;



/** WEBPACK FOOTER **
 ** ./src/components/home-slider.jsx
 **/